import React from 'react';
import { Select } from '@bedrock/components';
import { ListSearch } from '@bedrock/icons-react';
import type { TriggerComponent } from '../types';

/**
 * Select 触发器变体。
 * 还原 BProjectCodeSelect 的 DefaultChildren 模式：
 * Select + ListSearch 箭头，点击（mousedown 阻止下拉）触发弹窗。
 */
export const SelectVariant: TriggerComponent = ({
  displayValue,
  onClick,
  disabled,
  placeholder = '请选择',
  triggerProps,
}) => {
  const { style, ...rest } = (triggerProps ?? {}) as Record<string, unknown>;

  return (
    <Select
      arrow={<ListSearch />}
      disabled={disabled}
      placeholder={placeholder}
      options={displayValue ? [{ value: displayValue, name: displayValue }] : []}
      value={displayValue || undefined}
      onClick={onClick}
      onMouseDown={(e: React.MouseEvent) => {
        // 阻止 Select 默认下拉行为，交给 onTrigger 处理
        e.preventDefault();
      }}
      style={{ width: '100%', cursor: 'pointer', ...(style as React.CSSProperties) }}
      {...rest}
    />
  );
};
